import { createContext, useContext, useEffect, useState } from 'react';

export interface UserContextProps {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export type SetUserContextType = React.Dispatch<
  React.SetStateAction<UserContextProps>
>;

type UserContextType = {
  setUserContext: SetUserContextType;
  userContext: UserContextProps;
  setActiveEntity: React.Dispatch<React.SetStateAction<any | undefined>>;
  activeEntity: ActiveEntityProps | undefined;
  userId: string | undefined;
  setUserId: React.Dispatch<React.SetStateAction<string | undefined>>;
  avatar?: string;
  closed: boolean;
  setClosed: React.Dispatch<React.SetStateAction<boolean>>;
  mobileOpen: boolean;
  setMobileOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export interface ActiveEntityProps {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

const UserContext = createContext<UserContextType>({
  userContext: {},
  setUserContext: () => {},
  userId: undefined,
  setUserId: () => {},
  activeEntity: {},
  setActiveEntity: () => {},
  closed: false,
  setClosed: () => {},
  setMobileOpen: () => {},
  mobileOpen: false,
});

const UserContextProvider = ({ children }: { children: any }) => {
  // const { authToken, appLogout, setAuthToken } = useAuthContext();
  // const payload = parseJwt(authToken);
  // const { localStorage } = window;
  // const { setToastTheme } = useGlobalToast();
  const [userContext, setUserContext] = useState<UserContextProps>({});
  const [userId, setUserId] = useState<string | undefined>();
  const [activeEntity, setActiveEntity] = useState<ActiveEntityProps>();
  const [closed, setClosed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  // localStorage.getItem('closed') === 'true',

  /* updated closed */
  // useEffect(() => {
  //   localStorage.setItem('closed', closed ? 'true' : 'false');
  // }, [closed]);

  return (
    <UserContext.Provider
      value={{
        userContext,
        setUserContext,
        userId,
        setUserId,
        activeEntity,
        setActiveEntity,
        closed,
        setClosed,
        mobileOpen,
        setMobileOpen,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

const UserContextConsumer = UserContext.Consumer;

const ACCESSIBLE_PAGES = ['NEW_CHAT', 'HISTORY', 'EXPLORE', 'CHAT', 'STAFF'];

const usePermissions = () => {
  const userContext = useContext(UserContext);
  const [permissions, setPermissions] = useState<string[]>([]); // set any permission user should have based on value from userContext
  const [accessiblePages, setAccessiblePages] =
    useState<string[]>(ACCESSIBLE_PAGES); // set any page user should have based on value from userContext

  useEffect(() => {
    if (userContext.userContext) {
      setPermissions([]);
      setAccessiblePages(ACCESSIBLE_PAGES);
    }
  }, [userContext]);

  return { permissions, accessiblePages };
};

export const useFeatureFlags = () => {
  const flags: any[] = [];
  const flagEnabled = (flag: string): boolean => flags.includes(flag);

  return {
    flags,
    flagEnabled,
  };
};

export { usePermissions, UserContext, UserContextConsumer };

export default UserContextProvider;
